import { AudienceCards } from './components/AudienceCards';
import { ComplianceBadges } from './components/ComplianceBadges';
import { DualIdentityBlock } from './components/DualIdentityBlock';
import { FooterInstitutional } from './components/FooterInstitutional';
import { Hero } from './components/Hero';
import { HowItWorksTimeline } from './components/HowItWorksTimeline';
import { ManifestoBlock } from './components/ManifestoBlock';
import { PartnershipBlock } from './components/PartnershipBlock';
import { PrinciplesGrid } from './components/PrinciplesGrid';
import { RoadmapBar } from './components/RoadmapBar';
import { ScienceBlock } from './components/ScienceBlock';
import { ScreensShowcase } from './components/ScreensShowcase';
import { StickyNav } from './components/StickyNav';
import { TrustStrip } from './components/TrustStrip';

// ============================================================
// Lume institucional — composição das 12 seções
// ============================================================
// Single-page deep, ancoragem por âncoras (#manifesto, #para-quem-e,
// #como-funciona, #principios, #showcase, #ciencia, #conformidade,
// #parceria, #footer).
//
// Sem React Router — não precisamos de SPA aqui. A página é
// estática-ish, com microinterações via Framer Motion.
// ============================================================

export function App() {
  return (
    <>
      <a href="#main" className="skip-link">
        Pular para o conteúdo principal
      </a>

      <StickyNav />

      <main id="main">
        <Hero />
        <TrustStrip />
        <ManifestoBlock />
        <AudienceCards />
        <HowItWorksTimeline />
        <PrinciplesGrid />
        <ScreensShowcase />
        <ScienceBlock />
        <ComplianceBadges />
        <DualIdentityBlock />
        <RoadmapBar />
        <PartnershipBlock />
      </main>

      <FooterInstitutional />
    </>
  );
}
